import { useState } from 'react';
import React from 'react'
import Dropzone from "react-dropzone";


function evaluarCondicion(condicion, valorColumna, value) {
    switch (condicion) {
        case "=":
            return valorColumna === value;
        case "!=":
            return valorColumna !== value;
        // Agrega más casos para otras condiciones (por ejemplo, "<", ">", "<=", ">=") si es necesario
        default:
            return false; // Condición no válida
    }
}



const Matrix = (props) => {

    console.log(props)
    // Las respuestas se alinean por ID del item, NO por posicion en el array: la lista
    // de items cambia (se crean, se editan y se borran) y lo guardado en data_matrix es
    // una foto del momento en que se guardo. Casarlos por indice corria las evidencias
    // de una fila a otra y reventaba el guardado cuando sobraban filas guardadas.
    const matrixItems = props.matrix.matrix || [];
    const savedRows = props.matrix.data_matrix || null;

    const savedById = {};
    (savedRows || []).forEach((row) => {
        if (row && row.id !== undefined && row.id !== null) savedById[String(row.id)] = row;
    });

    // Una fila guardada por cada item actual, en el orden de los items.
    let defaultIsReady = !!savedRows;
    const valuesArray = matrixItems.map((question_matrix_item, indexFila) => {
        // Registros viejos guardados sin id en la fila: unico caso en que cae al indice.
        const saved = savedById[String(question_matrix_item.id)]
            || ((savedRows && savedRows[indexFila] && savedRows[indexFila].id === undefined) ? savedRows[indexFila] : null);

        if (!saved) {
            // Item nuevo (o sin respuesta): entra vacio y deja el boton habilitado.
            defaultIsReady = false;
            return { id: question_matrix_item.id, url: "", name: question_matrix_item.name, description: question_matrix_item.description, value: props.matrix.matrix_configuration.default_column, comments: "", dynamic_value: 0, file: "" };
        }

        // El nombre y la descripcion se refrescan del item: si lo renombraron en la
        // configuracion, el registro y su PDF muestran el nombre actual.
        return { ...saved, id: question_matrix_item.id, name: question_matrix_item.name, description: question_matrix_item.description, file: "" };
    });

    // Sobraban filas guardadas (items borrados): hay que volver a guardar para limpiarlas.
    if (savedRows && savedRows.length !== valuesArray.length) defaultIsReady = false;

    const [isLoading, setIsLoading] = useState(false);
    const [values, setValues] = useState(valuesArray);
    const [isReady, setIsReady] = useState(defaultIsReady);
    const [saveState, setSaveState] = useState(false);
    // Estado por-celda de la evidencia con IA: { [rowIndex]: { uploading, error } }
    const [fileStatus, setFileStatus] = useState({});

    const token = document.querySelector("[name='csrf-token']").content;
    const aiConfig = (props.matrix.matrix_configuration && props.matrix.matrix_configuration.taimes_ai_config) || null;
    const aiEnabled = !!(aiConfig && aiConfig.enabled);
    const fileSpecial = props.matrix.matrix_configuration && props.matrix.matrix_configuration.file_special_value;






    const handleChange = (event, rowIndex) => {
        props.setValues("", props.matrix.matrix_configuration.question_id);
        const { name, value } = event.target;
        const updatedValues = [...values]; // Clonar el array de valores



        // Actualizar el valor en la fila correspondiente
        updatedValues[rowIndex][name] = value;

        let resultado_final = checkConditios(rowIndex, value)

        updatedValues[rowIndex].dynamic_value = resultado_final;

        setIsReady(false)
        // Actualizar el estado con los nuevos valores
        setValues(updatedValues);
    };


    ///// CONDICIONES
    const checkConditios = (rowIndex, value) => {
        // Guarda: si la fila no tiene item detras, no hay condiciones que evaluar. Sin
        // esto, una fila sobrante rompia el guardado entero antes de llegar al fetch.
        const matrixItem = props.matrix.matrix[rowIndex];
        const conditions = (matrixItem && matrixItem.question_matrix_item_conditions) || [];
        console.log(conditions, "conditions")
        console.log(rowIndex, "rowIndex")
        console.log(value, "value")
        let condicionCumplida = false;
        let resultado_final = 0;
        conditions.forEach((condicion) => {
            if (!condicionCumplida) { // Verifica si aún no se ha cumplido una condición
                const resultado = evaluarCondicion(condicion.condition, condicion.value_column, value);
                if (resultado) {
                    resultado_final = condicion.value
                    condicionCumplida = true; // Marca que una condición se ha cumplido
                }
            }
        });
        console.log(resultado_final, "resultado_final")
        return resultado_final;
    }
    /////

    const handleChangeAndRadio = (event, rowIndex) => {
        props.setValues("", props.matrix.matrix_configuration.question_id);
        const { name, value, type, checked } = event.target;
        const updatedValues = [...values]; // Clonar el array de valores

        // Actualizar el valor en la fila correspondiente
        updatedValues[rowIndex].value = value;
        let resultado_final = checkConditios(rowIndex, value);
        updatedValues[rowIndex].dynamic_value = resultado_final;
        setIsReady(false)
        // Actualizar el estado con los nuevos valores
        setValues(updatedValues);
    };

    const handleChangeCheckbox = (event, rowIndex) => {

        props.setValues("", props.matrix.matrix_configuration.question_id);
        const { value, checked } = event.target;
        const updatedValues = [...values];
        setIsReady(false)
        if (checked) {
            // Agregar la opción seleccionada al array si se marca
            updatedValues[rowIndex].value = ([...updatedValues[rowIndex].value, value]);
            setValues(updatedValues)
        } else {
            // Quitar la opción seleccionada del array si se desmarca
            updatedValues[rowIndex].value = updatedValues[rowIndex].value.filter((option) => option !== value)
            setValues(updatedValues);
        }
    };

    const handleClick = () => {
        // Add validation for mandatory fields
        if (props.matrix.is_mandatory) {
            const hasEmptyValues = values.some(item =>
                !item.value ||
                item.value === "" ||
                (Array.isArray(item.value) && item.value.length === 0)
            );

            if (hasEmptyValues) {
                setSaveState(true);
                return;
            }
        }

        setSaveState(false);
        const updatedValues = [...values]
        updatedValues.map((item, index) => {
            let resultado_final = checkConditios(index, item.value);
            updatedValues[index].dynamic_value = resultado_final;
        })

        setIsLoading(true)
        console.log("setvalues", props.matrix.matrix_configuration.question_id)
        props.setValues("filled", props.matrix.matrix_configuration.question_id); // Llamar a la función desde el padre
        const formData = new FormData();
        values.forEach((objeto, indice) => {

            formData.append(`${objeto.id}`, objeto.file);

        })

        formData.append("data", JSON.stringify(values));



        fetch(`/formatos/update_ansewers_matix/${props.surveyId}/${props.matrix.matrix_configuration.question_id}`, {
            method: 'PATCH', // or 'PUT'
            body: formData, // data can be `string` or {object}!
            headers: {}
        })
            .then(res => res.json())
            .catch(error => console.error("Error:", error))
            .then(data => {
                setIsLoading(false)
                console.log(data.data, "dataa")
                console.log(data.set_value, "set_value")
                setValues(data.data)
                setIsReady(true)
                if (data.set_value) {
                    props.setValues("filled", props.matrix.matrix_configuration.question_id)
                    props.setValues(data.value_to_set.value, data.value_to_set.question)
                }

            });
    };



    const removeMatrixFile = (rowIndex) => {
        props.setValues("", props.matrix.matrix_configuration.question_id);
        setIsReady(false);
        const updatedValues = [...values];
        updatedValues[rowIndex].url = "";
        updatedValues[rowIndex].file = "";
        setValues(updatedValues);
        setFileStatus(prev => ({ ...prev, [rowIndex]: { uploading: false, error: "" } }));
    }

    const fileQuestion = (rowIndex) => {
        if (!values) return null;
        const status = fileStatus[rowIndex] || {};
        const row = values[rowIndex] || {};
        const dzAccept = (fileSpecial === "image" || fileSpecial === "camera") ? "image/*" : undefined;
        const dzCapture = fileSpecial === "camera" ? "environment" : undefined;
        const inputExtra = dzCapture ? { capture: dzCapture } : {};

        const url = row.url;
        const localFile = (!url && row.file && typeof row.file.name === "string") ? row.file : null;
        const attachedName = (row.file && (row.file.path || row.file.name)) || (url ? decodeURIComponent(url.split('/').pop().split('?')[0]) : null);
        const hasAttachment = !!url || !!attachedName;
        const isImage = url
            ? /\.(jpe?g|png|gif|webp|bmp|svg)(\?|$)/i.test(url)
            : (localFile ? /^image\//.test(localFile.type || "") : false);

        // Subiendo / validando
        if (status.uploading) {
            return (
                <div className="mtx-evidence--loading">
                    <i className="fas fa-spinner fa-spin"></i> Validando con IA…
                </div>
            );
        }

        // Evidencia adjunta (url ya subida, o archivo local recién elegido) → widget bonito
        if (hasAttachment) {
            return (
                <div className="bw-file-field bw-file-field--matrix">
                    <div className="bw-file-field__preview bw-file-field__preview--image">
                        {url ? (
                            <a className="bw-file-field__thumb" href={url} target="_blank" rel="noopener noreferrer">
                                {isImage
                                    ? <img src={url} alt={attachedName} />
                                    : <div className="bw-file-field__icon"><i className="fas fa-file-alt" /></div>}
                            </a>
                        ) : (
                            <div className="bw-file-field__thumb">
                                <div className="bw-file-field__icon"><i className={`fas ${isImage ? 'fa-image' : 'fa-file-alt'}`} /></div>
                            </div>
                        )}
                        <div className="bw-file-field__meta">
                            <div className="bw-file-field__meta-kind">{isImage ? "IMAGEN" : "ARCHIVO"}</div>
                            {url
                                ? <a className="bw-file-field__meta-name" href={url} target="_blank" rel="noopener noreferrer" title={attachedName}>{attachedName}</a>
                                : <span className="bw-file-field__meta-name" title={attachedName}>{attachedName}</span>}
                            <div className="mtx-inline-actions">
                                <Dropzone onDrop={(files) => HandleChangeFile(files, rowIndex)} accept={dzAccept} multiple={false}>
                                    {({ getRootProps, getInputProps }) => (
                                        <a {...getRootProps({ className: 'mtx-replace-link', title: 'Reemplazar' })}>
                                            <input {...getInputProps(inputExtra)} />
                                            <i className="fas fa-sync-alt" /> Reemplazar
                                        </a>
                                    )}
                                </Dropzone>
                                <button type="button" className="mtx-remove-link" onClick={() => removeMatrixFile(rowIndex)} title="Quitar">
                                    <i className="fas fa-trash-alt" /> Quitar
                                </button>
                            </div>
                        </div>
                        <div className="bw-file-field__actions">
                            <button type="button" className="bw-file-field__action bw-file-field__action--ghost bw-file-field__action--icon-only" onClick={() => removeMatrixFile(rowIndex)} title="Quitar"><i className="fas fa-trash-alt" /></button>
                        </div>
                    </div>
                    {status.error && <div className="mtx-evidence__error">{status.error}</div>}
                </div>
            );
        }

        // Evidencia vacía → dropzone bonito
        return (
            <Dropzone onDrop={(files) => HandleChangeFile(files, rowIndex)} accept={dzAccept}>
                {({ getRootProps, getInputProps }) => (
                    <div {...getRootProps({ className: `mtx-dropzone ${status.error ? 'mtx-dropzone--error' : ''}` })}>
                        <input {...getInputProps(inputExtra)} />
                        <i className={`fas ${dzCapture ? 'fa-camera' : 'fa-cloud-upload-alt'} mtx-dropzone__icon`} />
                        <span className="mtx-dropzone__text">
                            {status.error || (dzCapture ? "Tomar foto" : "Arrastre o toque para subir")}
                        </span>
                    </div>
                )}
            </Dropzone>
        );
    }

    const HandleChangeFile = (archivo, rowIndex) => {
        if (!archivo || archivo.length === 0) return;
        const file = archivo[0];

        // Sin IA: comportamiento de siempre (retener y subir al Guardar).
        if (!aiEnabled) {
            props.setValues("", props.matrix.matrix_configuration.question_id);
            setIsReady(false)
            const updatedValues = [...values];
            updatedValues[rowIndex].file = file;
            setValues(updatedValues)
            return;
        }

        // Con IA: subir al soltar (S3 directo) + validar por celda.
        uploadMatrixFileWithAI(file, rowIndex);
    }

    // Sube UNA evidencia a S3 (presign directo) y la valida con la IA en el acto.
    // Rechaza la celda si la IA responde datos.coincide=false; si pasa, guarda la
    // url y aplica el mapeo (comentario/valor). Soft-fail si la IA cae.
    const uploadMatrixFileWithAI = async (file, rowIndex) => {
        const questionId = props.matrix.matrix_configuration.question_id;
        const matrixItemId = values[rowIndex] && values[rowIndex].id;
        setFileStatus(prev => ({ ...prev, [rowIndex]: { uploading: true, error: "" } }));
        props.setValues("", questionId);
        setIsReady(false);

        try {
            // 1) Presign
            const presignRes = await fetch('/formatos/generate_matrix_upload_url', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json', 'X-CSRF-Token': token },
                body: JSON.stringify({
                    survey_id: props.surveyId, question_id: questionId, matrix_item_id: matrixItemId,
                    file_name: file.name, content_type: file.type, file_size: file.size
                })
            });
            if (!presignRes.ok) {
                const e = await presignRes.json().catch(() => ({}));
                throw new Error(e.error || 'No se pudo preparar la subida');
            }
            const { upload_url, file_key } = await presignRes.json();

            // 2) PUT a S3
            const putRes = await fetch(upload_url, {
                method: 'PUT',
                body: file,
                headers: { 'Content-Type': file.type, 'Content-Length': String(file.size) }
            });
            if (!putRes.ok) throw new Error('No se pudo subir el archivo');

            // 3) Validación IA
            const checkRes = await fetch('/formatos/matrix_file_ai_check', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json', 'X-CSRF-Token': token },
                body: JSON.stringify({
                    survey_id: props.surveyId, question_id: questionId,
                    matrix_item_id: matrixItemId, file_key
                })
            });
            const body = await checkRes.json().catch(() => ({}));

            if (!checkRes.ok) {
                // Rechazada por la IA (o error). NO dejamos la evidencia.
                setFileStatus(prev => ({ ...prev, [rowIndex]: { uploading: false, error: body.error || 'La evidencia fue rechazada.' } }));
                return;
            }

            // Aceptada: guardar url + aplicar mapeo (filled).
            const updatedValues = [...values];
            updatedValues[rowIndex].url = body.file_url;
            updatedValues[rowIndex].file = { path: file.name };
            const filled = body.filled || {};
            if (filled.comentario != null && filled.comentario !== "") {
                updatedValues[rowIndex].comments = String(filled.comentario);
            }
            if (filled.valor != null && filled.valor !== "") {
                updatedValues[rowIndex].value = String(filled.valor);
                updatedValues[rowIndex].dynamic_value = checkConditios(rowIndex, String(filled.valor));
            }
            setValues(updatedValues);
            setFileStatus(prev => ({ ...prev, [rowIndex]: { uploading: false, error: "" } }));
        } catch (err) {
            setFileStatus(prev => ({ ...prev, [rowIndex]: { uploading: false, error: err.message || 'Error subiendo la evidencia' } }));
        }
    }


    const handleChangeComments = (event, rowIndex) => {
        props.setValues("", props.matrix.matrix_configuration.question_id);
        const { name, value, type, checked } = event.target;
        const updatedValues = [...values]; // Clonar el array de valores

        // Actualizar el valor en la fila correspondiente
        updatedValues[rowIndex].comments = value;
        setIsReady(false)
        // Actualizar el estado con los nuevos valores
        setValues(updatedValues);
    }

    const warningMessage = saveState && (
        <div className="alert alert-danger" role="alert">
            Debe completar todos los campos de la matriz
        </div>
    );

    if (props.matrix.matrix_configuration.type_question == "checkbox" || props.matrix.matrix_configuration.type_question == "radio") {
        return (
            <React.Fragment>
                {warningMessage}
                <div className="mtx-survey">
                <div style={{ overflowX: 'auto' }}>
                    <table className='table'>
                        <thead>
                            <tr>
                                <th scope="col"></th>
                                {props.matrix.matrix_configuration.columns.map((columna, index) => (
                                    <React.Fragment>
                                        <th className='text-center' scope="col" key={index}>{columna} </th>
                                    </React.Fragment>
                                ))}
                                {props.matrix.matrix_configuration.has_file && (<th className="mtx-evidence-th">Evidencia</th>)}
                                {props.matrix.matrix_configuration.has_commets && (<th>Comentarios</th>)}
                            </tr>
                        </thead>
                        <tbody>
                            {props.matrix.matrix.map((question_matrix_item, indexFila) => (
                                <React.Fragment key={indexFila}>
                                <tr>
                                    <td className="mtx-item-name">{question_matrix_item.name}<br /><span style={{ fontSize: "12px", color: "whitesomoke" }}>{question_matrix_item.description}</span></td>
                                    {props.matrix.matrix_configuration.columns.map((columna, index) => (
                                        <td className='text-center mtx-option' data-label={columna} key={index}>
                                            {props.matrix.matrix_configuration.type_question === "checkbox" ? (
                                                <input
                                                    value={columna}
                                                    checked={values[indexFila] && values[indexFila].value && values[indexFila].value.includes(columna)}
                                                    onChange={(event) => handleChangeCheckbox(event, indexFila)}
                                                    type="checkbox"
                                                />
                                            ) : (
                                                <input
                                                    checked={values[indexFila] && values[indexFila].value === columna}
                                                    value={columna}
                                                    onChange={(event) => handleChangeAndRadio(event, indexFila)}
                                                    type="radio"
                                                /*   name={`radio_${indexFila}__${question_matrix_item.id}_${columna}`}  */// Nombre único para cada fila
                                                />
                                            )}
                                        </td>
                                    ))}
                                    {props.matrix.matrix_configuration.has_file && (<td className='mtx-block mtx-evidence-col' data-label="Evidencia">{fileQuestion(indexFila)}</td>)}
                                    <input type="hidden" value={values[indexFila] && values[indexFila].dynamic_value} />
                                    {props.matrix.matrix_configuration.has_commets && (<td className='mtx-block' data-label="Comentarios"><textarea className='form form-control' type="text" value={values[indexFila] && values[indexFila].comments || ''} onChange={(event) => handleChangeComments(event, indexFila)} /> </td>)}
                                </tr>
                                </React.Fragment>
                            ))}
                        </tbody>

                    </table>
                </div>
                </div>
                <div className='text-right' > <button className={`${!isReady ? "btn btn-success" : "btn btn-light"}`} disabled={isLoading || isReady} onClick={handleClick}>{isLoading ? "Guardando...." : (isReady ? "Guardado" : "Guardar")}</button></div>
            </React.Fragment>
        )
    } else {
        return (
            <React.Fragment>
                {warningMessage}
                <div className="mtx-survey">
                <table className='table'>
                    <thead>
                        <tr>
                            <th scope="col">Fila</th>
                            <th className='text-center' scope="col">Calificación</th>
                            {props.matrix.matrix_configuration.has_file && (<th className="mtx-evidence-th">Evidencia</th>)}
                            {props.matrix.matrix_configuration.has_commets && (<th>Comentarios</th>)}
                        </tr>
                    </thead>
                    <tbody>
                        {props.matrix.matrix.map((question_matrix_item, index) => (
                            <React.Fragment key={index}>
                                <tr>
                                    <td className="mtx-item-name">
                                        {question_matrix_item.name} <br /><span style={{ fontSize: "12px", color: "whitesomoke" }}>{question_matrix_item.description}</span>
                                    </td>
                                    <td className="mtx-block" data-label="Calificación">
                                        <select
                                            name="value" // Cambia esto según el nombre de la propiedad en valuesArray
                                            className='form form-control'
                                            value={values[index] && values[index].value || ''}
                                            onChange={(event) => handleChange(event, index)}
                                        >
                                            <option value="">Seleccione de columna</option>
                                            {props.matrix.matrix_configuration.columns.map((columna, columnIndex) => (
                                                <option value={columna} key={columnIndex}>{columna}</option>
                                            ))}
                                        </select>
                                        {/*  {values[index].dynamic_value} */}
                                    </td>

                                    {props.matrix.matrix_configuration.has_file && (<td className="mtx-block mtx-evidence-col" data-label="Evidencia">{fileQuestion(index)}</td>)}
                                    <input type="hidden" value={values[index] && values[index].dynamic_value} />
                                    {props.matrix.matrix_configuration.has_commets && (<td className="mtx-block" data-label="Comentarios"><textarea className='form form-control' type="text" value={values[index] && values[index].comments || ''} onChange={(event) => handleChangeComments(event, index)} /> </td>)}

                                </tr>
                            </React.Fragment>
                        ))}
                    </tbody>

                </table>
                </div>
                <div className='text-right' > <button className={`${!isReady ? "btn btn-success" : "btn btn-light"}`} disabled={isLoading || isReady} onClick={handleClick}>{isLoading ? "Guardando...." : (isReady ? "Guardado" : "Guardar")}</button></div>

            </React.Fragment>
        )
    }
}


export default Matrix;